import { useState } from "react";
import { DatePicker } from "react-rainbow-components";
import styled from "styled-components";

import { selectBus, setFaq } from "../redux/FaqSlice";
import { useSelector } from "react-redux/es/exports";

import { TbArrowsLeftRight } from "react-icons/tb";
import { BsPlusLg } from "react-icons/bs";
import { AiOutlineMinus } from "react-icons/ai";
import Support from "../components/Supports";
import Faq from "../components/FAQ";
import { Helmet } from "react-helmet";
import { Inputs } from "./TrainTicket";
import { DatePickers } from "./TrainTicket";

const BusTicket = () => {
  const [date, setDate] = useState(new Date());
  const [isoneWay, setIsOneWay] = useState("single");

  const questions = useSelector(selectBus);

  let FaqElems = questions.map((question) => {
    return Object.entries(question)[1];
  });

  return (
    <>
      <Helmet>
        <title>بلیط اتوبوس | علی گشت</title>
      </Helmet>

      <Inputs>
        <input type="text" placeholder="مبدا(شهر)" className="textInput" />
        <input
          type="text"
          placeholder="مقصد (شهر)"
          className="textInput"
          style={{ paddingRight: "25px" }}
        />
        <button className="changeCities" style={{top:'66px'}}>
          <TbArrowsLeftRight />
        </button>
        <DatePickers
          value={date}
          name="انتخاب تاریخ سفر"
          placeholder="انتخاب تاریخ سفر"
          onChange={(value) => setDate(value)}
          selectionType={isoneWay}
          label="انتخاب تاریخ سفر"
        />

        <button className="searchButton">جستجو</button>
      </Inputs>

      <Support />

      <Faq FaqElems={FaqElems} />
    </>
  );
};

export default BusTicket;
